import { toLower } from 'ramda'

export const maskType = {
  MASK_PHONE_RU: 'mask_phone_ru',
  MASK_PHONE_KG: 'mask_phone_kg',
  MASK_PHONE_KZ: 'mask_phone_kz',
  MASK_PHONE_UA: 'mask_phone_ua',
  MASK_SNILS: 'mask_snils',
  MASK_DATE: 'mask_date',
  MASK_DAY_MONTH: 'mask_day_month',
  MASK_TIME: 'mask_time',
  // реализуемые через PlainInputMaskedCustom
  MASK_TIME_CUSTOM: 'mask_time_custom',
  MASK_WEEKDAY_TIME: 'mask_weekday_time',
  MASK_WEEKDAY_SHORT_TIME: 'mask_weekday_short_time',
} as const

export type MaskType = (typeof maskType)[keyof typeof maskType]

export const getPhoneMaskTypeByIsoCode = (isoCode: string) => {
  const code = toLower(isoCode)
  if (code === 'kg') return maskType.MASK_PHONE_KG
  if (code === 'kz') return maskType.MASK_PHONE_KZ
  if (code === 'ua') return maskType.MASK_PHONE_UA
  return maskType.MASK_PHONE_RU
}
